module.exports = __webpack_public_path__ + "media/student_v2/assets/images/checkbox/student-alert-checkbox-indeterminate-05127914090656110114417c956b16c0.svg";